import { EdGenericCalendarWeekdays } from '@/core/components/ed-generic-calendar/interfaces/ed-generic-calendar-weekdays.interface';
import { ABWorkingdays, ABWorkingdaysLabels, ScheduleTypeEnum } from '@/tools/enums/schedule-type.enum';
import { ScheduleBlock } from '@/tools/models/class-builder.models';
import { PlaceholderService } from '@/tools/services/placeholder.service';
import { ScheduleService } from '@/tools/services/schedule.service';
import { WORKING_DAYS } from '@/tools/values/schedule.values';

import Moment from 'moment';

export class ClassScheduleProvider {
  classId: number = 0;
  weekdays: number[] | EdGenericCalendarWeekdays[] = [0, 1, 2, 3, 4, 5, 6];
  scheduleBlockInEdition: ScheduleBlock = null;
  scheduleBlocksCreated: ScheduleBlock[] = [];
  scheduleStartHour: string = '08:00';
  scheduleEndHour: string = '19:00';
  subjects = [];
  subjectsAdded = [];
  teachers = [];
  calendarZoomInDisabled = false;
  calendarZoomOutDisabled = true;
  scheduleType: ScheduleTypeEnum = ScheduleTypeEnum.WEEK;
  scheduleShortDay: string = '';

  get isWeeklySchedule(): boolean {
    return this.scheduleType === ScheduleTypeEnum.WEEK;
  }

  transformFromVuePickerToString(time: any): string {
    return Moment(`${time.hh}:${time.mm} ${time.A}`, 'HH:mm A').format('HH:mm');
  }

  transformFromStringToVuePicker(time: string): any {
    const moment = Moment(time, 'HH:mm');

    return {
      hh: moment.format('hh'),
      mm: moment.format('mm'),
      A: moment.format('A'),
    }
  }

  async saveScheduleHours(startHour: string, endHour: string): Promise<void> {
    await ScheduleService.saveScheduleHours(
      startHour,
      endHour,
      this.classId,
    );

    this.scheduleStartHour = startHour;
    this.scheduleEndHour = endHour;
  }

  async removeSubject(subjectId: number): Promise<void> {
    await PlaceholderService.deletePlaceholder(
      this.classId,
      subjectId
    );

    this.subjectsAdded = this.subjectsAdded.filter(
      subject => subject.id !== subjectId
    );
  }

  setWeekdays(weekdays: number[]) {
    this.scheduleType = ScheduleTypeEnum.WEEK;
    this.weekdays = weekdays.map(day => Number(WORKING_DAYS[day]));
  }

  setABWeekdays(hasShortDays: boolean = false) {
    this.scheduleType = ScheduleTypeEnum.AB;
    this.weekdays = [
      { day: 0, key: ABWorkingdays.A },
      { day: 1, key: ABWorkingdays.B },
    ];

    if (hasShortDays) {
      this.weekdays.push({ day: 2, key: ABWorkingdays.AS });
      this.weekdays.push({ day: 3, key: ABWorkingdays.BS });
    }
  }

  setScheduleShortDay(shortDay: string): void {
    this.scheduleShortDay = shortDay;
    this.setABWeekdays(true);
  }

  getScheduleShortDay(): string {
    return this.scheduleShortDay;
  }
}